// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-detail {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 40px 80px;
}

.back-btn {
  background: none;
  color: var(--gold);
  font-size: 16px;
  font-family: var(--font-body);
  margin-bottom: 24px;
  padding: 8px 0;
}

.back-btn:hover {
  text-decoration: underline;
}

.item-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
}

.item-images {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.main-image {
  width: 100%;
  aspect-ratio: 1;
  background-color: #ddd5c7;
  border-radius: 16px;
  overflow: hidden;
}

.main-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-light);
  background-color: #ddd5c7;
  font-family: var(--font-body);
}

.image-thumbnails {
  display: flex;
  gap: 12px;
  overflow-x: auto;
}

.thumbnail {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color 0.3s ease;
}

.thumbnail:hover {
  border-color: var(--gold);
}

.thumbnail.active {
  border-color: var(--gold);
}

.thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.item-details h1 {
  font-family: var(--font-body);
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
  color: var(--dark);
}

.category {
  color: var(--text-light);
  font-size: 16px;
  margin-bottom: 16px;
}

.price {
  font-size: 36px;
  font-weight: 700;
  color: var(--gold);
  margin-bottom: 24px;
}

.description {
  margin-bottom: 24px;
}

.description h3 {
  font-size: 18px;
  margin-bottom: 8px;
  font-weight: 700;
}

.description p {
  color: var(--dark);
  line-height: 1.6;
}

.stock-info {
  margin-bottom: 24px;
}

.in-stock {
  color: var(--success);
  font-weight: 500;
}

.out-of-stock-detail {
  color: var(--error);
  font-weight: 500;
}

.purchase-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.quantity-selector {
  display: flex;
  align-items: center;
  gap: 12px;
}

.quantity-selector label {
  font-weight: 500;
}

.quantity-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 2px solid var(--border);
  border-radius: 8px;
  padding: 4px 8px;
}

.quantity-controls button {
  width: 32px;
  height: 32px;
  background-color: var(--dark);
  color: var(--bg);
  border-radius: 4px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quantity-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.quantity-controls span {
  font-size: 18px;
  font-weight: 600;
  min-width: 40px;
  text-align: center;
}

.add-to-cart-btn {
  width: 100%;
  padding: 16px;
  font-size: 18px;
}

@media (max-width: 768px) {
  .item-detail {
    padding: 16px 16px 60px;
  }

  .item-content {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .item-details h1 {
    font-size: 24px;
  }

  .price {
    font-size: 28px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ItemDetail.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".item-detail {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px 40px 80px;\n}\n\n.back-btn {\n  background: none;\n  color: var(--gold);\n  font-size: 16px;\n  font-family: var(--font-body);\n  margin-bottom: 24px;\n  padding: 8px 0;\n}\n\n.back-btn:hover {\n  text-decoration: underline;\n}\n\n.item-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 48px;\n}\n\n.item-images {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.main-image {\n  width: 100%;\n  aspect-ratio: 1;\n  background-color: #ddd5c7;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.main-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.image-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-light);\n  background-color: #ddd5c7;\n  font-family: var(--font-body);\n}\n\n.image-thumbnails {\n  display: flex;\n  gap: 12px;\n  overflow-x: auto;\n}\n\n.thumbnail {\n  width: 80px;\n  height: 80px;\n  border-radius: 8px;\n  overflow: hidden;\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: border-color 0.3s ease;\n}\n\n.thumbnail:hover {\n  border-color: var(--gold);\n}\n\n.thumbnail.active {\n  border-color: var(--gold);\n}\n\n.thumbnail img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.item-details h1 {\n  font-family: var(--font-body);\n  font-size: 28px;\n  font-weight: 700;\n  margin-bottom: 8px;\n  color: var(--dark);\n}\n\n.category {\n  color: var(--text-light);\n  font-size: 16px;\n  margin-bottom: 16px;\n}\n\n.price {\n  font-size: 36px;\n  font-weight: 700;\n  color: var(--gold);\n  margin-bottom: 24px;\n}\n\n.description {\n  margin-bottom: 24px;\n}\n\n.description h3 {\n  font-size: 18px;\n  margin-bottom: 8px;\n  font-weight: 700;\n}\n\n.description p {\n  color: var(--dark);\n  line-height: 1.6;\n}\n\n.stock-info {\n  margin-bottom: 24px;\n}\n\n.in-stock {\n  color: var(--success);\n  font-weight: 500;\n}\n\n.out-of-stock-detail {\n  color: var(--error);\n  font-weight: 500;\n}\n\n.purchase-section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.quantity-selector {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.quantity-selector label {\n  font-weight: 500;\n}\n\n.quantity-controls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border: 2px solid var(--border);\n  border-radius: 8px;\n  padding: 4px 8px;\n}\n\n.quantity-controls button {\n  width: 32px;\n  height: 32px;\n  background-color: var(--dark);\n  color: var(--bg);\n  border-radius: 4px;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.quantity-controls button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.quantity-controls span {\n  font-size: 18px;\n  font-weight: 600;\n  min-width: 40px;\n  text-align: center;\n}\n\n.add-to-cart-btn {\n  width: 100%;\n  padding: 16px;\n  font-size: 18px;\n}\n\n@media (max-width: 768px) {\n  .item-detail {\n    padding: 16px 16px 60px;\n  }\n\n  .item-content {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .item-details h1 {\n    font-size: 24px;\n  }\n\n  .price {\n    font-size: 28px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
